import type { FC } from 'react';

import Labels from '../labels/labels';
import type { MetadataTagCloudSelectValue } from '../metadata_form_field/metadata_form_field';

import styles from './segment_value_tag.module.css';

type Props = {
  value: MetadataTagCloudSelectValue[];
};

export const SegmentValueTag: FC<Props> = (props) => {
  const values = props.value ?? [];
  return <Labels items={values} className={styles.labels} variant="gray" />;
};
